import { GrantsType, hasScopedPermission } from '../../Shared/utils/auth';

export const viewAdminPortalPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'system', 'partners.read') ||
  hasScopedPermission(grants, 'system', 'portal_users.read') ||
  hasScopedPermission(grants, 'partner', 'portal_users.read') ||
  hasScopedPermission(grants, 'partner', 'partners.read');
